<template>
  <span
    v-if="badge"
    v-bind="$attrs"
    class="yn-svg-icon-wrapper position-relative"
  >
    <component
      :is="resolvedIcon"
      :size="size"
      :stroke-width="strokeWidth"
    />
    <span
      class="badge badge-up badge-pill"
      :class="badgeClasses"
    >
      {{ badge }}
    </span>
  </span>
  <component
    v-else
    :is="resolvedIcon"
    v-bind="$attrs"
    :size="size"
    :stroke-width="strokeWidth"
  />
</template>

<script>
import { computed, defineComponent } from 'vue'

const ctx = require.context('./', false, /\.vue$/)
const iconMap = {}

ctx.keys().forEach(key => {
  if (key === './SvgIcon.vue') return

  const name = key.replace('./', '').replace('.vue', '')
  iconMap[name] = ctx(key).default
  iconMap[`${name}Icon`] = ctx(key).default
})

export default defineComponent({
  name: 'SvgIcon',
  inheritAttrs: false,
  props: {
    icon: {
      type: [String, Object, Function],
      default: 'CircleIcon',
    },
    size: {
      type: [String, Number],
      default: '14',
    },
    strokeWidth: {
      type: [String, Number],
      default: 2,
    },
    badge: {
      type: [String, Object, Number],
      default: null,
    },
    badgeClasses: {
      type: [String, Object, Array],
      default: 'badge-primary',
    },
  },
  setup(props) {
    const resolvedIcon = computed(() => {
      if (props.icon && typeof props.icon !== 'string') return props.icon

      const iconName = props.icon || 'CircleIcon'
      return iconMap[iconName] || iconMap[iconName.replace(/Icon$/, '')] || iconMap.Circle
    })

    return {
      resolvedIcon,
    }
  },
})
</script>
